import { concat } from "lodash";

export const QUEUE_TYPES = [
  {
    key: "normal",
    name: "Normal",
  },
  {
    key: "usual",
    name: "Habitual",
  },
  {
    key: "vip",
    name: "VIP",
  },
  {
    key: "noanswer",
    name: "No coger",
  },
  {
    key: "hold",
    name: "En espera",
  },
  {
    key: "transfer",
    name: "Desviadas",
  },
];

export const GENERIC_BT_MODEL = 1033;
export const KBO_BT_MODEL = 1101;

export const BT_MODELS = [
  {
    value: 1007,
    label: "Genérico radio",
  },
  {
    value: 1027,
    label: "Genérico ntx",
  },
  {
    value: 1028,
    label: "Genérico gpio-inv",
  },
  {
    value: 1030,
    label: "Genérico radio-inv-lamp",
  },
  {
    value: 1033,
    label: "Genérico",
  },
  {
    value: 1011,
    label: "Genérico 11",
  },
  {
    value: 1017,
    label: "Genérico 17",
  },
  {
    value: 1101,
    label: "KBO_v1",
  },
  {
    value: 1102,
    label: "KBO AirLink",
  },
  {
    value: 2001,
    label: "MulticomPlus & MulticomPro",
  },
  {
    value: 3001,
    label: "Nitax",
  },
  {
    value: 4001,
    label: "eWhere",
  },
  {
    value: 4002,
    label: "eWhere v2",
  },
];

export const WAITING_QUEUE = 2;
export const TRANSFER_QUEUE = 3;
export const NO_ANSWER_QUEUE = 6;

export const KBO_COLOR = "#007196";

export const COLORS = [
  "#ADA7FC",
  "#EC6F86",
  "#FEDC75",
  "#9FF4C2",
  "#4673E7",
  "#D187EF",
  "#FE816D",
  "#79DD75",
  "#7F69FF",
  "#FDA6F8",
  "#FFBB6D",
  "#B2DD30",
  "#46B4E7",
  "#AD61ED",
];

export const CHART_COLORS = concat(
  COLORS,
  COLORS,
  COLORS,
  COLORS,
  COLORS,
  COLORS,
  COLORS,
  COLORS,
  COLORS,
  COLORS,
  COLORS,
  COLORS,
  COLORS,
  COLORS
);

export const NOTIFICATION_GIVE_BACK_TYPE = 4;
export const NOTIFICATION_ABSENCE_TYPE = 3;

export const POLYLINE_COLORS = ["#FF0000", "#FFA500", "#008000", "#0000FF", "#4815AA", "#FFEE00"];

export const STATE_BOOKED_CANCELED = 4;
export const SERVICE_STATES = [
  {
    id: 1,
    label: "Iniciado",
    key: "STARTING",
  },
  {
    id: 2,
    label: "Despachado",
    key: "DISPATCHED",
  },
  {
    id: 3,
    label: "Pausado",
    key: "PAUSED",
  },
  {
    id: 4,
    style: {
      textDecoration: "line-through",
    },
    label: "Reserva Cancelada",
    key: "BOOKED_CANCELED",
  },
  {
    // Not in use
    id: 5,
    style: {
      textDecoration: "line-through",
    },
    label: "Cancelado",
    key: "CANCELED",
  },
  {
    id: 6,
    label: "Finalizado",
    key: "FINISHED",
  },
  {
    id: 90,
    label: "No lanzado",
    key: "NOT_LAUNCHED",
  },
];

export const TRIP_STATES = [
  {
    id: 1,
    label: "Iniciado",
    key: "STARTING",
  },
  {
    id: 2,
    label: "Buscando taxi",
    key: "SEARCHING",
  },
  {
    id: 3,
    label: "Subasta",
    key: "AUCTION",
  },
  {
    id: 4,
    label: "Pendiente",
    key: "PENDING",
  },
  {
    id: 21,
    searchable: true,
    label: "No aceptado",
    key: "NOT_ACEPTED",
  },
  {
    id: 22,
    label: "En cola",
    key: "QUEUED",
  },
  {
    id: 6,
    label: "En curso",
    key: "ON_TAXI",
  },
  {
    id: 7,
    searchable: true,
    label: "Finalizado",
    key: "FINISH",
  },
  {
    id: 8,
    searchable: true,
    label: "Devuelto",
    key: "GIVE_BACK",
  },
  {
    id: 9,
    searchable: true,
    label: "Cliente ausente",
    key: "NO_CLIENT",
  },
  {
    id: 10,
    searchable: true,
    style: {
      textDecoration: "line-through",
    },
    label: "Cancelado operadora",
    key: "OP_CANCEL",
  },
  {
    id: 11,
    searchable: true,
    style: {
      textDecoration: "line-through",
    },
    label: "Cancelado tiempo",
    key: "TIME_CANCEL",
  },
  {
    id: 12,
    label: "Finalizado auto",
    key: "AUTO_FINISH",
  },
  {
    id: 90,
    label: "Despacho con error",
    key: "NOT_LAUNCHED",
  },
];

export const NORMAL_STATE = 1;
export const PAUSED_STATE = 3;
export const FINISHED_STATE = 7;
export const GIVE_BACK_STATE = 8;
export const NO_CLIENT_STATE = 9;
export const CANCELLED_STATE = 10;

export const AVAILABLE_EXTENSIONS = [
  { key: 0, label: "Sin teléfono" },
  { key: "101", label: "Extensión 101" },
  { key: "102", label: "Extensión 102" },
  { key: "103", label: "Extensión 103" },
  { key: "104", label: "Extensión 104" },
  { key: "105", label: "Extensión 105" },
  { key: "106", label: "Extensión 106" },
  { key: "107", label: "Extensión 107" },
  { key: "108", label: "Extensión 108" },
  { key: "109", label: "Extensión 109" },
  { key: "110", label: "Extensión 110" },
  { key: "111", label: "Extensión 111" },
  { key: "112", label: "Extensión 112" },
  { key: "113", label: "Extensión 113" },
  { key: "114", label: "Extensión 114" },
  { key: "115", label: "Extensión 115" },
];

export const SCHEDULE_TYPES = [
  { id: 1, key: "now", label: "Inmediato" },
  { id: 2, key: "booking", label: "Reserva" },
  { id: 3, key: "periodic", label: "Periódico" },
  { id: 4, key: "historic", label: "Histórico" },
];
export const SCHEDULE_TYPE_NOW_ID = 1;
export const SCHEDULE_TYPE_BOOKING_ID = 2;
export const SCHEDULE_TYPE_PERIODIC_ID = 3;
export const SCHEDULE_TYPE_HISTORIC_ID = 4;
export const SCHEDULE_TYPE_NOW = "now";
export const SCHEDULE_TYPE_BOOKING = "booking";
export const SCHEDULE_TYPE_PERIODIC = "periodic";
export const SCHEDULE_TYPE_HISTORIC = "historic";
export const SCHEDULE_TYPE_LIST = "list";
export const SCHEDULE_TYPES_LABEL = {
  now: "despacho",
  booking: "reserva",
  periodic: "periódico",
  historic: "histórico",
  list: "lista",
};

export const BOOKING_SHORT_DATE_FORMAT = "dd D, HH:mm";

export const DESTINATION_LABELS = {
  welcome: "Operadoras desde fijos",
  "welcome-fromMobile": "Operadoras desde móviles",
  opAuto: "Operador automática desde fijos",
  "opAuto-fromMobile": "Operador automática desde móviles",
  commerces: "Modo comercio desde fijos",
  "commerces-fromMobile": "Modo comercio desde móviles",
  "time-cancel": "Cancelado tiempo",
};

export const COMMERCE_ROLE = 6;

export const SANCTIONS = [
  { label: "Sin sanción", value: 0 },
  { label: "5 min", value: 5 },
  { label: "15 min", value: 15 },
  { label: "30 min", value: 30 },
  { label: "45 min", value: 45 },
  { label: "1h", value: 60 },
  { label: "2h", value: 120 },
  { label: "6h", value: 360 },
  { label: "12h", value: 720 },
  { label: "24h", value: 1440 },
  { label: "Introducir valor", value: "custom" },
];

export const NOTIFICATION_TYPE_ALARM = 1;
export const NOTIFICATION_TYPE_VOICE = 2;
export const NOTIFICATION_TYPE_NO_CLIENT = 3;
export const NOTIFICATION_TYPE_GIVE_BACK = 4;
export const NOTIFICATION_TYPE_PTT = 5;
export const NOTIFICATION_TYPE_STREET_ERRORS = 10;
export const NOTIFICATION_TYPE_ZONES_ERRORS = 11;

export const DEFAULT_ADVANCE = 5;

export const TICKET_STATUS = {
  RESOLVED: {
    key: "RESOLVED",
    label: "Resuelto",
    textStyle: {
      color: "rgb(55, 173, 55)",
    },
    tagStyle: {
      backgroundColor: "rgb(55, 173, 55)",
      borderColor: "rgb(58, 172, 58)",
    },
  },
  PENDING_KBO: {
    key: "PENDING_KBO",
    label: "Pendiente Sistema",
    textStyle: {
      color: "rgb(103, 133, 161)",
    },
    tagStyle: {
      backgroundColor: "rgb(103, 133, 161)",
      borderColor: "rgb(103, 133, 161)",
    },
  },
  PENDING_SYSTEM: {
    key: "PENDING_SYSTEM",
    label: "Pendiente Sistema",
    textStyle: {
      color: "rgb(103, 133, 161)",
    },
    tagStyle: {
      backgroundColor: "rgb(103, 133, 161)",
      borderColor: "rgb(103, 133, 161)",
    },
  },
  WORKING: {
    key: "WORKING",
    label: "En revisión",
    textStyle: {
      color: "rgb(4, 98, 186)",
    },
    tagStyle: {
      backgroundColor: "rgb(4, 98, 186)",
      borderColor: "rgb(4, 98, 186)",
    },
  },
  PENDING_USER: {
    key: "PENDING_USER",
    label: "Pendiente Usuario",
    textStyle: {
      color: "rgb(218, 108, 5)",
    },
    tagStyle: {
      backgroundColor: "rgb(245, 167, 23)",
      borderColor: "rgb(228, 155, 21)",
    },
  },
};

export const SERVICE_FORM_FIELDS = [
  {
    key: "workgroup",
    label: "Workgroup",
    enabled: true,
  },
  {
    key: "customer.phone",
    label: "Cliente > Teléfono",
    enabled: true,
  },
  {
    key: "customer.queue",
    label: "Cliente > Cola",
    enabled: true,
  },
  {
    key: "customer.incompatibility",
    label: "Cliente > Incompatibilidad",
    enabled: true,
  },
  {
    key: "customer.name",
    label: "Cliente > Nombre",
    enabled: true,
  },
  {
    key: "customer.notes",
    label: "Cliente > Notas",
    enabled: true,
  },
  {
    key: "customer.opAuto",
    label: "Cliente > Op. Auto",
    enabled: true,
  },
  {
    key: "customer.pideTaxi",
    label: "Cliente > Pide Taxi",
    enabled: true,
  },
  {
    key: "customer.eliza",
    label: "Cliente > Eliza",
    enabled: true,
  },
  {
    key: "from.street",
    label: "Dirección origen > Calle o punto de interés",
    enabled: true,
  },
  {
    key: "from.portal",
    label: "Dirección origen > Portal",
    enabled: true,
  },
  {
    key: "from.letter",
    label: "Dirección origen > Letra",
    enabled: true,
  },
  {
    key: "from.hint",
    label: "Dirección origen > Aclaración",
    enabled: true,
  },
  {
    key: "from.passenger",
    label: "Dirección origen > Nombre pasajero",
    enabled: true,
  },
  {
    key: "from.notes",
    label: "Dirección origen > Notas",
    enabled: true,
  },
  {
    key: "from.specialInstructions",
    label: "Instrucciones especiales",
    enabled: false,
  },
  {
    key: "to.street",
    label: "Dirección destino > Calle o punto de interés",
    enabled: true,
  },
  {
    key: "to.portal",
    label: "Dirección destino > Portal",
    enabled: true,
  },
  {
    key: "to.letter",
    label: "Dirección destino > Letra",
    enabled: true,
  },
  {
    key: "to.notes",
    label: "Dirección destino > Notas",
    enabled: true,
  },
  {
    key: "requirements",
    label: "Requisitos",
    enabled: true,
  },
  {
    key: "properties.paused",
    label: "Propiedades > Pausado antes de salir",
    enabled: true,
  },
  {
    key: "properties.taxis",
    label: "Propiedades > Número de taxis",
    enabled: true,
  },
  {
    key: "properties.fixedTaxi",
    label: "Propiedades > Taxi",
    enabled: true,
  },
  {
    key: "properties.price",
    label: "Propiedades > Precio",
    enabled: true,
  },
  {
    key: "stages.stage1",
    label: "Propiedades > Etapa 1",
    enabled: true,
  },
  {
    key: "stages.stage2",
    label: "Propiedades > Etapa 2",
    enabled: true,
  },
  {
    key: "stages.stage3",
    label: "Propiedades > Etapa 3",
    enabled: true,
  },
  {
    key: "stages.stage4",
    label: "Propiedades > Etapa 4",
    enabled: true,
  },
  {
    key: "stages.stage5",
    label: "Propiedades > Etapa 5",
    enabled: true,
  },
  {
    key: "stages.stage6",
    label: "Propiedades > Etapa 6",
    enabled: true,
  },
  {
    key: "stages.stage7",
    label: "Propiedades > Etapa 7",
    enabled: true,
  },
  {
    key: "stages.stage8",
    label: "Propiedades > Etapa 8",
    enabled: true,
  },
  {
    key: "subscriber.subscriber",
    label: "Abonado > Abonado",
    enabled: true,
  },
  {
    key: "subscriber.authorizer",
    label: "Abonado > Autorizador",
    enabled: true,
  },
  {
    key: "subscriber.user",
    label: "Abonado > Usuario",
    enabled: true,
  },
  {
    key: "subscriber.fixedPrice",
    label: "Abonado > Precio fijo",
    enabled: true,
  },
  {
    key: "subscriber.notes",
    label: "Abonado > Notas",
    enabled: true,
  },
  {
    key: "action.send",
    label: "Acción > Enviar",
    enabled: true,
  },
  {
    key: "action.cancel",
    label: "Acción > Cancelar",
    enabled: true,
  },
];

export const S3_BUCKET = "operator.app.data.2kbo.com";
export const S3_SIGNATURES_BUCKET = "system.trips.2kbo";
export const S3_LOGS_BUCKET = "logs.backend.2kbo.com";
export const ADD_NOTE_ON_BOOKINGS_WGS = [6, 2];
export const IGNORE_ALARM_NOTIFICATIONS_WGS = [25];
export const GOOGLE_MAPS_API_KEY = "";

export const DOCUMENTDB_ENDPOINT = "https://documentdb.eu-west-1.amazonaws.com";
export const DOCUMENTDB_REGION = "eu-west-1";
export const DOCUMENTDB_ACCESS_KEY = "";
export const DOCUMENTDB_SECRET_KEY = "";

export const CASH_CENTRAL = 1;
export const CASH_TAXIS = 2;
export const WIRE_TRANSFER = 3;
export const DRAFT_NOW = 4;
export const DRAFT_30 = 5;
export const DRAFT_60 = 6;
export const DRAFT_90 = 7;
export const BANK_CHECK = 8;
export const PAYMENT_METHODS = {
  [CASH_CENTRAL]: "Efectivo central",
  [CASH_TAXIS]: "Efectivo taxista",
  [WIRE_TRANSFER]: "Transferencia",
  [DRAFT_NOW]: "Giro a la vista",
  [DRAFT_30]: "Giro a 30 días",
  [DRAFT_60]: "Giro a 60 días",
  [DRAFT_90]: "Giro a 90 días",
  [BANK_CHECK]: "Cheque",
};
export const BILLING_DATE_OPTIONS = {
  1: "Sin fecha preferida de facturación",
  2: "Principio de mes",
  3: "Mediados de mes",
  4: "Finales de mes",
  5: "Semanalmente",
};
export const INVOICE_LINE_OPTIONS = {
  1: "Campos separados",
  2: "Campos condensados",
};
export const LINE_PRICE_OPTIONS = {
  1: "Mostrarlo sin IVA",
  2: "Mostrarlo con IVA",
};
export const TAXI_WIRE_TRANSFER = 1;

export const TAXI_STATES = {
  OFFLINE: 1,
  TIMEOUT: 2,
  FREE: 3,
  BUSY: 4,
  TARGET_NF: 5,
  IN_NF: 6,
};

export const TAXI_STATE_CONFIG = {
  [TAXI_STATES.FREE]: {
    label: "Libre",
    type: "success",
    color: "green",
    bgColor: "#13ce66",
  },
  [TAXI_STATES.BUSY]: {
    label: "Ocupado",
    type: "danger",
    color: "red",
    bgColor: "#ff4949",
  },
  [TAXI_STATES.DESTINATION]: {
    label: "Destino",
    type: "warning",
    color: "yellow",
    bgColor: "#fead0a",
  },
  [TAXI_STATES.FINALIZING]: {
    label: "Finalizando",
    type: "primary",
    color: "blue",
    bgColor: "#1879ff",
  },
};
export const TAXI_CASH = 2;
export const TAXI_PAYMENT_METHODS = {
  [TAXI_WIRE_TRANSFER]: "Transferencia bancaria",
  [TAXI_CASH]: "Efectivo",
};

export const NERVION_WG = 9;
export const KBO_WG = 6;
export const BILBAO_WG = 1;
export const VIGO_WG = 25;
export const ESMACA_WG = 10;
export const BURGOS_WG = 12;
export const ENJOY_BCN_WG = 14;
export const SANTANDER_WG = 13;
export const JOVELLANOS_WG = 4;
export const AVILES_WG = 5;
export const VALLINA_WG = 33;
export const ZARAGOZA_WG = 26;

export const WORKGROUPS_WITH_MULTIPLE_SERVICES = [KBO_WG, NERVION_WG, VALLINA_WG];

export const KBO_TAXIS_SERVICE_NAMES = ["KBO Taxis", "Taxis"];
export const SERVICES_PROVIDED = [
  "KBO Taxi",
  "Taxis",
  "Oficina",
  "Nortegas",
  "Violencia",
  "Asistencia Guipuzcoa",
  "N41 Vintage",
  "Sistelec",
  "Vaillant",
  "Vallina",
];
export const SERVICES_PROVIDED_BY_WORKGROUP = {
  [VALLINA_WG]: ["Vallina", "Taxis"],
  [KBO_WG]: ["KBO Taxi"],
  [NERVION_WG]: [
    "KBO Taxi",
    "Oficina",
    "Nortegas",
    "Violencia",
    "Asistencia Guipuzcoa",
    "N41 Vintage",
    "Sistelec",
    "Vaillant",
  ],
};

export const END_CALL_TYPES = [
  { id: 1, key: "AFTER_SAY_LICENSE", name: "Después de licencia" },
  { id: 2, key: "WAITING_FOR_LICENSE", name: "Esperando licencia" },
  { id: 3, key: "CANCELED_BY_TIME", name: "Cancelada por tiempo" },
  { id: 4, key: "OP_HANG_UP", name: "Colgó la operadora" },
  { id: 5, key: "WAITING_INCOMING_QUEUE", name: "Esperando cola" },
  { id: 6, key: "IN_OP_AUTO", name: "Operadora Auto." },
  { id: 7, key: "IN_ELIZA", name: "Eliza" },
  { id: 8, key: "IN_WELCOME", name: "Mensaje bienvenida" },
  { id: 9, key: "TALKING_WITH_OP", name: "Hablando con operadora" },
  { id: 0, key: "IN_COMMERCES", name: "Comercio" },
];

export const ABANDONED_CALL_TYPE = 5; // Assuming than waiting in the incoming means abandone the call

const ENTER_FREE = 1;
const ENTER_HAND_TRIP = 2;
const ENTER_CENTRAL_TRIP = 3;
const EXIT_FREE = 4;
const EXIT_HAND_TRIP = 5;
const EXIT_CENTRAL_TRIP = 6;
export const TAXI_ZONE_ACTIONS = {
  [ENTER_FREE]: "Entra libre",
  [ENTER_HAND_TRIP]: "Entra con servicio de calle",
  [ENTER_CENTRAL_TRIP]: "Entrada con servicio de central",
  [EXIT_FREE]: "Sale libre",
  [EXIT_HAND_TRIP]: "Sale con servicio de calle",
  [EXIT_CENTRAL_TRIP]: "Sale con servicio de central",
};

export const DELIVERY_TRIGGER_ALWAYS = 1;
export const DELIVERY_TRIGGER_REQS = 2;
export const DELIVERY_TRIGGERS = {
  [DELIVERY_TRIGGER_ALWAYS]: "Siempre",
  [DELIVERY_TRIGGER_REQS]: "Siempre que cumpla requisitos",
};

export const DEFAULT_SANCTION_TYPES = {
  REFUSE_TRIP: "101",
  IGNORE_TRIP: "102",
};

export const SANCTION_MODE = {
  "Echar de la app": 1,
  "No puede recibir servicios": 2,
};

export const SANCTION_TRIGGERS = {
  "En parada y en zona": "always",
  "Solo en parada": "onlyAtStop",
};

export const CONCEPT_TYPES = {
  fixed: "Fijo",
  perService: "Por servicio",
};

export const PERIODIC_REPORT_PERIODICITY_LAST_MONTH = "lastMonth";
export const PERIODIC_REPORT_PERIODICITY_LAST_WEEK = "lastWeek";
export const PERIODIC_REPORT_PERIODICITY_LAST_DAY = "lastDay";
export const PERIODIC_REPORTS_PERIODICITY_HISTORIC = {
  [PERIODIC_REPORT_PERIODICITY_LAST_MONTH]: "Último mes",
  [PERIODIC_REPORT_PERIODICITY_LAST_WEEK]: "Última semana",
  [PERIODIC_REPORT_PERIODICITY_LAST_DAY]: "Diario",
};
export const PERIODIC_REPORT_PERIODICITY_NEXT_MONTH = "nextMonth";
export const PERIODIC_REPORT_PERIODICITY_NEXT_WEEK = "nextWeek";
export const PERIODIC_REPORT_PERIODICITY_NEXT_DAY = "nextDay";
export const PERIODIC_REPORTS_PERIODICITY_BOOKINGS = {
  [PERIODIC_REPORT_PERIODICITY_NEXT_MONTH]: "Próximo mes",
  [PERIODIC_REPORT_PERIODICITY_NEXT_WEEK]: "Próxima semana",
  [PERIODIC_REPORT_PERIODICITY_NEXT_DAY]: "Próximo día",
};
export const PERIODIC_REPORTS_PERIODICITY_ALL = {
  ...PERIODIC_REPORTS_PERIODICITY_HISTORIC,
  ...PERIODIC_REPORTS_PERIODICITY_BOOKINGS,
};

export const PERIODIC_REPORT_TYPE_HISTORIC = "historicServices";
export const PERIODIC_REPORT_TYPE_SCHEDULED_SERVICES = "scheduledServices";
export const PERIODIC_REPORT_TYPE_PER_TAXI_SERVICES = "perTaxiServices";
export const PERIODIC_REPORT_TYPE_PER_SUBSCRIBER_SERVICES = "perSubscriberServices";
export const PERIODIC_REPORT_TYPES = {
  [PERIODIC_REPORT_TYPE_HISTORIC]: "Histórico de servicios",
  [PERIODIC_REPORT_TYPE_SCHEDULED_SERVICES]: "Reservas",
  [PERIODIC_REPORT_TYPE_PER_TAXI_SERVICES]: "Servicios por cada taxi",
  [PERIODIC_REPORT_TYPE_PER_SUBSCRIBER_SERVICES]: "Servicios por cada taxi",
};

export const LICENSE_TYPE_REGULAR = "0";
const LICENSE_TYPE_LITE = "1";
const LICENSE_TYPE_ALL = "2";
export const LICENSE_TYPES = [
  { id: LICENSE_TYPE_ALL, label: "Todas las licencias" },
  { id: LICENSE_TYPE_REGULAR, label: "Licencias estandar" },
  { id: LICENSE_TYPE_LITE, label: "Licencias lite" },
];

export const CALENDAR_APPLICATION_TAXI_CANT_LOG = 1;
export const CALENDAR_APPLICATION_TAXI_CANT_RECEIVE_SERVICES = 2;
export const CALENDAR_APPLICATION_TAXI_PUNISH_ZONES = 3;
export const CALENDAR_APPLICATION_TAXI_IMPROVES_ZONES = 4;
export const CALENDAR_APPLICATIONS = [
  { id: CALENDAR_APPLICATION_TAXI_CANT_LOG, label: "No puede loguearse" },
  {
    id: CALENDAR_APPLICATION_TAXI_CANT_RECEIVE_SERVICES,
    label: "No puede recibir servicios",
  },
  { id: CALENDAR_APPLICATION_TAXI_PUNISH_ZONES, label: "Desventaja en zonas" },
  { id: CALENDAR_APPLICATION_TAXI_IMPROVES_ZONES, label: "Con preferencia en zonas" },
];

export const SUPER_ADMIN_ROLE_ID = 1;
